/* src/app/components/add-custom-tip/add-custom-tip.component.scss */
.wrapper {
  width: 90%;
  margin: 15px auto;
}
h3 {
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0em;
}
ion-item {
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  font-size: 16px !important;
  color: black;
}
ion-item ion-label {
  margin-left: 10px;
}
.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}
.button-block ion-button {
  color: var(--ion-color-secondary);
  --border-radius: 28px;
  border-radius: 28px;
  width: 48%;
  height: 57px;
  font-size: 15px;
  text-transform: none;
  border: 2px solid var(--ion-color-secondary);
}
.button-block .button:last-child {
  border: none;
  --border-radius: 28px;
  color: white;
}
ion-icon {
  z-index: 10;
}
/*# sourceMappingURL=add-custom-tip.component.css.map */
